import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { Button } from "../../../../components";
import { isVideoFormat } from "../IntroMediaUpload.utils";

type VideoPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  mediaUrl: string;
  format: string;
};

export const VideoPreviewModal: React.FC<VideoPreviewModalProps> = ({
  isOpen,
  onClose,
  mediaUrl,
  format,
}) => {
  const [aspectRatio, setAspectRatio] = useState(16 / 9);

  // Reset aspect ratio when modal opens or media URL changes
  useEffect(() => {
    if (isOpen && isVideoFormat(format)) {
      setAspectRatio(16 / 9);
    }
  }, [isOpen, mediaUrl, format]);

  const handleLoadedMetadata = (
    event: React.SyntheticEvent<HTMLVideoElement>
  ) => {
    const video = event.currentTarget;
    if (video.videoWidth > 0 && video.videoHeight > 0) {
      setAspectRatio(video.videoWidth / video.videoHeight);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent
        maxW="960px"
        w="90%"
        mt="80px"
        mb="auto"
        borderRadius="24px"
        h="599px"
        maxH="calc(100vh - 80px)"
        display="flex"
        flexDirection="column"
      >
        <ModalHeader py={6} px={6} flexShrink={0}>
          <Flex justify="space-between" align="center" width="100%">
            <Text fontSize="24px" fontWeight="semibold" color="gray.800">
              Preview
            </Text>
            <ModalCloseButton position="static" />
          </Flex>
        </ModalHeader>
        <ModalBody
          px={6}
          pt={6}
          pb={6}
          display="flex"
          flexDirection="column"
          flex={1}
          overflow="hidden"
          minH={0}
          alignItems="center"
          justifyContent="center"
        >
          {isVideoFormat(format) && mediaUrl ? (
            <Box
              width="100%"
              maxW="600px"
              mx="auto"
              borderRadius="md"
              overflow="hidden"
              bg="black"
              position="relative"
              flexShrink={0}
              style={{ aspectRatio }}
            >
              <video
                src={mediaUrl}
                controls
                onLoadedMetadata={handleLoadedMetadata}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          ) : (
            <Box
              width="100%"
              maxW="600px"
              mx="auto"
              borderRadius="md"
              border="1px dashed"
              borderColor="purple.200"
              bg="purple.50"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
              style={{ aspectRatio: "16/9" }}
            >
              <Text fontSize="sm" color="gray.600" textAlign="center">
                Video goes here
              </Text>
            </Box>
          )}
        </ModalBody>
        <ModalFooter
          py={6}
          px={6}
          justifyContent="center"
          flexShrink={0}
          borderTop="1px solid"
          borderColor="gray.200"
        >
          <Button
            onClick={onClose}
            bg="blue.700"
            color="white"
            _hover={{ bg: "blue.800" }}
            borderRadius="8px"
            px={6}
          >
            Done
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
